import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection } from "../../../actions";
import Intro from "./Intro";
// import Bleed from '../../Bleed'
import Dialog from "../../Dialog";
import Search from "./Search";
import localStorageWrapper from "../../../services/localStorageWrapper";

class GraphicsTools extends React.Component {
  state = {
    showDialog: false,
  };

  componentDidMount() {
    // Set 'Graphics' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Graphics" });

    this.dialog = {
      title: "Designer's Tip",
      message:
        "Click on your graphic to adjust the size, using the dots scale.",
      topPosition: 250,
      leftPosition: 100,
      origin: "bottomright",
    };

    // Expiration for local storage
    this.graphicsTimestamp = Date.now();
    const expires = 60 * 60 * 1000 * 24;

    // Delete local storage after 24 hours
    if (
      this.graphicsTimestamp -
        localStorageWrapper.getItem("fypGraphicsDialogShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypGraphicsDialogShown");
      localStorageWrapper.removeItem("fypGraphicsDialogShownTimestamp");
    }
  }

  onShowDialog = () => {
    if (
      !this.state.showDialog &&
      !localStorageWrapper.getItem("fypGraphicsDialogShown")
    ) {
      this.setState({
        showDialog: true,
      });

      this.setLocalStorage();
    }
  };

  handleHideDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  setLocalStorage = () => {
    // Set local storage for 24 hours to remember that the tips have been shown
    localStorageWrapper.setItem("fypGraphicsDialogShown", true);
    localStorageWrapper.setItem(
      "fypGraphicsDialogShownTimestamp",
      this.graphicsTimestamp,
    );
  };

  render() {
    const clipartReady = Object.keys(this.props.clipart).length !== 0;
    return (
      <div className="tools-container tools-container--graphics">
        {this.state.showDialog && this.dialog && (
          <Dialog dialog={this.dialog} onHideDialog={this.handleHideDialog} />
        )}
        <Intro />
        {/*<Bleed />*/}
        {clipartReady && <Search onShowDialog={this.onShowDialog} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    clipart: state.clipart.clipart,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    { selectToolCollection: selectToolCollection },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(GraphicsTools);
